import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, NavLink, useLocation } from 'react-router-dom';
import Home from './components/Home';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import './App.css';

function AppContent() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  // Close mobile menu when route changes
  useEffect(() => {
    closeMobileMenu();
  }, [location.pathname]);

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileMenuOpen]);

  return (
    <div className="App">
      <header className="app-header">
        <div className="header-container">
          <div className="header-brand">
            <NavLink to="/" className="brand-link" onClick={closeMobileMenu}>
              <div className="brand-content">
                <h1 className="app-title">Jo Jo</h1>
              </div>
            </NavLink>
          </div>
          
          {/* Desktop Navigation */}
          <nav className="app-nav desktop-nav">
            <NavLink 
              to="/" 
              className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
              end
            >
              <i className="fas fa-home"></i>
              <span>Home</span>
            </NavLink>
            <NavLink 
              to="/privacy" 
              className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
            >
              <i className="fas fa-shield-alt"></i>
              <span>Privacy</span>
            </NavLink>
            <NavLink 
              to="/terms" 
              className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
            >
              <i className="fas fa-file-contract"></i>
              <span>Terms</span>
            </NavLink>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            className={`mobile-menu-toggle ${mobileMenuOpen ? 'active' : ''}`}
            onClick={toggleMobileMenu}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>

        {/* Mobile Navigation */}
        <nav className={`app-nav mobile-nav ${mobileMenuOpen ? 'open' : ''}`}>
          <NavLink 
            to="/" 
            className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
            end
            onClick={closeMobileMenu}
          >
            <i className="fas fa-home"></i>
            <span>Home</span>
          </NavLink>
          <NavLink 
            to="/privacy" 
            className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
            onClick={closeMobileMenu}
          >
            <i className="fas fa-shield-alt"></i>
            <span>Privacy Policy</span>
          </NavLink>
          <NavLink 
            to="/terms" 
            className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
            onClick={closeMobileMenu}
          >
            <i className="fas fa-file-contract"></i>
            <span>Terms of Service</span>
          </NavLink>
        </nav>

        {/* Logos Section */}
        <div className="header-logos">
          <div className="header-logos-container">
            <img src="/echo.png" alt="Echo Dev Studio Logo" className="header-main-logo" />
            <img src="/logo.png" alt="Jo Jo Bot Logo" className="header-sub-logo" />
          </div>
        </div>
      </header>
      
      <main className="app-main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
        </Routes>
      </main>
      
      <footer className="app-footer">
        <div className="footer-brand">
          <img src="/logo.png" alt="Echo Dev Studio Logo" className="footer-studio-logo" />
          <p>&copy; 2025 Echo Dev Studio. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;

